(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["timeline"] && !window.DesignMode) return;
  try {
    

let timelineBtns = document.querySelectorAll(".timeline_btn");
timelineBtns.forEach((btn) => {
  btn.addEventListener("click", () => {
    let blockId = btn.getAttribute("data-id").replace("btn-", "")

    let collapseText = document.querySelector(`[data-id="text-${blockId}"]`)

    collapseText.classList.toggle("visible")

    if(collapseText.classList.contains("visible")) btn.classList.add("active")
    else btn.classList.remove("active")
  })
})
  

  } catch(e) { console.error(e); }
})();

})();
